import {KPIController} from "./KPIController"

class GTMController {
	static EVENTS = {
		ALBUM_PAGE: 'open_page_album',
		ALBUM_BUY: 'open_album_buy',
		ALBUM_SHARE: 'open_album_share',
		ALBUM_PLAY: 'open_album_play_album',
		ALBUM_TRACK_PLAY: 'open_album_play_track',
		ALBUM_TRY_QOBUZ: 'open_album_try',
		ALBUM_LOGO_QOBUZ: 'open_album_qobuzlogo',
		TRACK_PAGE: 'open_page_track',
		TRACK_BUY: 'open_track_buy',
		TRACK_SHARE: 'open_track_share',
		TRACK_PLAY: 'open_track_play_track',
		TRACK_TRY_QOBUZ: 'open_track_try',
		TRACK_LOGO_QOBUZ: 'open_track_qobuzlogo',
		ARTIST_PAGE: 'open_page_artist',
		ARTIST_BUY: 'open_artist_buy',
		ARTIST_SHARE: 'open_artist_share',
		ARTIST_ALBUM_PLAY: 'open_artist_play_album',
		ARTIST_TRACK_PLAY: 'open_artist_play_track',
		ARTIST_TRY_QOBUZ: 'open_artist_try',
		ARTIST_LOGO_QOBUZ: 'open_artist_qobuzlogo',
		ARTIST_MORE_ALBUM: 'open_artist_morealbum',
		PLAYLIST_PAGE: 'open_page_playlist',
		PLAYLIST_SHARE: 'open_playlist_share',
		PLAYLIST_PLAY: 'open_play_play_playlist',
		PLAYLIST_TRACK_PLAY: 'open_playlist_play_track',
		PLAYLIST_TRY_QOBUZ: 'open_playlist_try',
		PLAYLIST_LOGO_QOBUZ: 'open_playlist_qobuzlogo',
		FOCUS_PAGE: 'open_page_focus',
		FOCUS_SHARE: 'open_focus_share',
		FOCUS_TRY_QOBUZ: 'open_focus_try',
		FOCUS_LOGO_QOBUZ: 'open_focus_qobuzlogo',
		FOCUS_PLAY: 'open_focus_play_album',
	}

	static TYPES = {
		ARTIST: 'Artist',
		ALBUM: 'Album',
		TRACK: 'Track',
		PLAYLIST: 'playlist',
		FOCUS: 'Focus',
	}

	static initialized = false
	static languageCode = ''
	static countryCode = ''
	static env = ''
	static pageChanged = true
	static lastLocation = undefined

	static init(country, language) {
		GTMController.languageCode = language
		GTMController.countryCode = country
		switch (process.env.NODE_ENV) {
			case 'development':
				GTMController.env = 'dev'
				break
			case 'test':
				GTMController.env = 'preprod'
				break
			case 'production':
				GTMController.env = 'prod'
				break
			default:
				break
		}
		GTMController.initGTM(window, document, 'script', 'dataLayer', 'GTM-MTLV8X8')
	}

	static initGTM = (w, d, s, l, i) => {
		w[l] = w[l] || []
		w[l].push({
			'gtm.start': new Date().getTime(), event: 'gtm.js'
		})
		const f = d.getElementsByTagName(s)[0]
		const j = d.createElement(s)
		const dl = (l !== 'dataLayer') ? `&l='${1}` : ''
		j.async = true
		j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`
		f.parentNode.insertBefore(j, f)
	}

	static pushEvent = (eventType) => {
		GTMController.push({ event: eventType })
	}

	static pushPlayEvent = (eventType) => {
		const pathParts = location.pathname.split('/')
		const id = pathParts[2]
		switch (eventType) {
			case GTMController.EVENTS.TRACK_PLAY:
				KPIController.pushPlayEvent(KPIController.EVENT_SUBTYPE.PLAY.STARTED, KPIController.RESOURCES_TYPE.TRACK, id)
				break
			case GTMController.EVENTS.ARTIST_TRACK_PLAY:
			case GTMController.EVENTS.ARTIST_ALBUM_PLAY:
				KPIController.pushPlayEvent(KPIController.EVENT_SUBTYPE.PLAY.STARTED, KPIController.RESOURCES_TYPE.ARTIST, id)
				break
			case GTMController.EVENTS.ALBUM_TRACK_PLAY:
				KPIController.pushPlayEvent(KPIController.EVENT_SUBTYPE.PLAY.STARTED, KPIController.RESOURCES_TYPE.ALBUM, id)
				break
			default:
				break
		}
		GTMController.push({ event: eventType })
	}

	static push = (event) => {
		window.dataLayer.push(event)
	}

	static pushShareEvent = (eventType, shareEventType) => {
		const pathParts = location.pathname.split('/')
		const id = pathParts[2]
		if (shareEventType) {
			switch (eventType) {
				case GTMController.EVENTS.TRACK_SHARE:
					KPIController.pushShareEvent(shareEventType, KPIController.RESOURCES_TYPE.TRACK, id)
					break
				case GTMController.EVENTS.ARTIST_SHARE:
					KPIController.pushShareEvent(shareEventType, KPIController.RESOURCES_TYPE.ARTIST, id)
					break
				case GTMController.EVENTS.ALBUM_SHARE:
					KPIController.pushShareEvent(shareEventType, KPIController.RESOURCES_TYPE.ALBUM, id)
					break
				default:
					break
			}
		}
		GTMController.push({ event: eventType })
	}

	static pushAlbumPageEvent = (albumId, albumTitle, albumArtist, category) => {
		GTMController.pushPageEvent(GTMController.TYPES.ALBUM, {
			open: {
				albumId,
				albumTitle,
				albumArtist,
				category
			},
			event: GTMController.EVENTS.ALBUM_PAGE
		})
	}

	static pushFocusPageEvent = (author, title) => {
		GTMController.pushPageEvent(GTMController.TYPES.FOCUS, {
			content: {
				author,
				title,
				type: GTMController.TYPES.FOCUS.toLowerCase()
			},
			event: GTMController.EVENTS.FOCUS_PAGE
		})
	}

	static pushArtistPageEvent = (artistName) => {
		GTMController.pushPageEvent(GTMController.TYPES.ARTIST, {
			open: {
				artistName
			},
			event: GTMController.EVENTS.ARTIST_PAGE
		})
	}

	static pushTrackPageEvent = () => {
		GTMController.pushPageEvent(GTMController.TYPES.TRACK, {
			event: GTMController.EVENTS.TRACK_PAGE
		})
	}

	static pushPlaylistPageEvent = () => {
		GTMController.pushPageEvent(GTMController.TYPES.PLAYLIST, {
			event: GTMController.EVENTS.PLAYLIST_PAGE
		})
	}

	static pushPageEvent = (pageType, event) => {
		if (GTMController.pageChanged && GTMController.lastLocation !== pageType) {
			GTMController.pageChanged = false
			GTMController.lastLocation = pageType
			GTMController.push({
				...GTMController.getPage(pageType),
				...event
			})
		}
	}

	static getPage = (subSection) => ({
		page: {
			environment: GTMController.env,
			siteSection: 'Open Qobuz',
			subSiteSection: subSection,
			siteType: 'Open Qobuz',
			country: {
				code: GTMController.countryCode,
				language: GTMController.languageCode
			}
		}
	})

	static pushTryQobuzEvent = () => {
		switch(window.location.pathname.split('/')[1]) {
			case 'playlist':
				GTMController.pushEvent(GTMController.EVENTS.PLAYLIST_TRY_QOBUZ)
				return
			case 'artist':
				GTMController.pushEvent(GTMController.EVENTS.ARTIST_TRY_QOBUZ)
				return
			case 'focus':
				GTMController.pushEvent(GTMController.EVENTS.FOCUS_TRY_QOBUZ)
				return
			case 'album':
				GTMController.pushEvent(GTMController.EVENTS.ALBUM_TRY_QOBUZ)
				return
			case 'track':
				GTMController.pushEvent(GTMController.EVENTS.TRACK_TRY_QOBUZ)
				return
			default:
				return 'Unknown'
		}
	}

	static getSubSiteSection() {
		switch (window.location.pathname.split('/')[1]) {
			case 'playlist':
				return GTMController.TYPES.PLAYLIST
			case 'artist':
				return GTMController.TYPES.ARTIST
			case 'focus':
				return GTMController.TYPES.FOCUS
			case 'album':
				return GTMController.TYPES.ALBUM
			case 'track':
				return GTMController.TYPES.TRACK
			default:
				return 'Unknown'
		}
	}

	static pushLogoClickedEvent = () => {
		switch(window.location.pathname.split('/')[1]) {
			case 'playlist':
				GTMController.pushEvent(GTMController.EVENTS.PLAYLIST_LOGO_QOBUZ)
				return
			case 'artist':
				GTMController.pushEvent(GTMController.EVENTS.ALBUM_LOGO_QOBUZ)
				return
			case 'focus':
				GTMController.pushEvent(GTMController.EVENTS.FOCUS_LOGO_QOBUZ)
				return
			case 'album':
				GTMController.pushEvent(GTMController.EVENTS.ALBUM_LOGO_QOBUZ)
				return
			case 'track':
				GTMController.pushEvent(GTMController.EVENTS.TRACK_LOGO_QOBUZ)
				return
			default:
				return 'Unknown'
		}
	}

	static onLocationChanged = () => {
		GTMController.pageChanged = true
	}
}

export default GTMController



// WEBPACK FOOTER //
// ./src/utils/kpi/GTMController.js